import { SvgIcon } from 'components/UIComponents/SvgIcon';

import { snack } from '@alixpartners/ui-components';
import './ButtonClipboardCopy.css';

interface Props {
  children?: React.ReactNode;
  clipboardText: string;
  tooltip?: string;
  onClick?: () => void;
}

export const ButtonClipboardCopy = ({
  clipboardText,
  tooltip,
  children,
  onClick,
}: Props) => {
  const handleClick = async () => {
    onClick?.();
    try {
      await navigator.clipboard.writeText(clipboardText);
      showToastInfoMessage('Copied to clipboard');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <button className="button-clipboard-copy" title={tooltip} onClick={handleClick}>
      {children}
      <SvgIcon iconName="copy" fill="currentColor" height={16} />
    </button>
  );
};

const showToastInfoMessage = (message: string) => {
  snack.info({ message, position: 'bottom-right', showIcon: true, hideAfter: 1 });
};
